import React from 'react';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import classNames from 'classnames';

import CheckboxRadio from 'common/CheckboxRadio';

const baseString = 'vra-crop-selector';
const classString = classNames({
  [`${baseString}`]: true
});
const CropSelector = ({
  activeCropId,
  onSelectCrop,
  supportedCrops
}) => {
  const radioOptions = supportedCrops.map((crop) => {
    return (
      <CheckboxRadio
        dataTestId={`${baseString}-${crop.name.toLowerCase()}`}
        isChecked={`${crop.id}` === activeCropId}
        key={crop.id}
        labelText={crop.name}
        name='cropSelector'
        onChange={() => { onSelectCrop({ id: crop.id }); }}
        type='radio'
      />
    );
  });

  return (
    <section className={classString}>
      <header>{getMessage('label-text__i-will-be-planting')}</header>
      {radioOptions}
    </section>
  );
};
CropSelector.propTypes = {
  activeCropId: propTypes.string.isRequired,
  onSelectCrop: propTypes.func.isRequired,
  supportedCrops: propTypes.array.isRequired
};
export default CropSelector;
